<div class="obrebook">
    <div class="step1header" *ngIf=step1>
        <div>
            <div class="onboardtitle">Book Onboard & Save 15%</div>

        </div>
        <div class="tenpxtop"></div>
        <app-itinerary-explorer-intro></app-itinerary-explorer-intro>
        <div class="tenpxtop"></div>


        <!-- 

        <div class="sectiontitle">Create a New Booking</div>
        <div class="italic">Follow all required steps</div>
        <div class="tenpxtop"></div> -->
    </div>
    <mat-stepper #stepper>

        <!-- #docregion label -->
        <mat-step label="">

            <!-- <div class=" instruction">Select Guests to Rebook</div> -->



            <!-- <div class="guestselection" *ngFor="let bookingguest of BookingGuestsInfo; let i=index;">
                <div class="row">
                    <div class="col-2"></div>
                    <div class="col-10">
                        <div class="funnelitemlist">
                            <input class="funnelselector" type="checkbox" id="guest{{i}}" name="guestselector"
                                value="guest{{i}}" [(ngModel)]="bookingguest.checked"
                                (change)="selectedFolio = '{{bookingguest.foluid}}';selectedTentative=undefined" />
                            <label for="guest{{i}}">{{bookingguest.folFullNameSal}}</label>
                        </div>
                    </div>
                </div>

            </div> -->

            <div>
                <div class="tentativelist" *ngIf="FolioBookingsInfo!=undefined && FolioBookingsInfo.length>0">
                    <div class="tenpxtop"></div>
                    <app-longgoldbar></app-longgoldbar>

                    <div class="sectiontitle">Confirm an Existing Quote</div>
                    <div class="tenpxtop"></div>
                    <div class="instruction">Click on an option for your cruise departure</div>

                    <div class="scrollareamedium">
                        <div class="bookingselection" *ngFor="let tentative of FolioBookingsInfo; let i=index;">

                            <div class="col-12 eventselector" (click)="setTentative(tentative)"
                                [ngClass]="{'eventselhighlight': selectedTentative!=undefined && selectedTentative.rebuid === tentative.rebuid }">
                                <div class="row ">
                                    <div class="col-1"></div>
                                    <div class="col-11">
                                        <div class="itineraryname">{{tentative.CruiseName}}</div>
                                        <div class="departuredate">{{tentative.DepartureDate | date:'mediumDate'}} -
                                            {{tentative.EndDate | date:'mediumDate'}}</div>
                                        <div class="shipname">{{tentative.Ship}}<span class="roomcat">
                                                - {{tentative.RoomCat}}</span></div>
                                        <div class="departurecity">{{tentative.Starting}} - {{tentative.Ending}}</div>

                                    </div>

                                </div>
                            </div>
                            <div class="row ">
                                <div class="col-12" align="center">

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="row OBbuttonarea ">
                <div class="col-6"></div>
                <div class="col-6" align="center">
                    <!-- <button *ngIf="selectedFolio==undefined && selectedTentative==undefined"
                        class="btn btn-outline-secondary" matStepperNext (click)="flagstep1(false);"
                        [disabled]="selectedFolio==undefined && selectedTentative==undefined">Next</button>
                    <button *ngIf="selectedFolio!=undefined" class="btn btn-outline-secondary" matStepperNext
                        (click)="flagstep1(false);setselectedguests();" [disabled]="selectedFolio==undefined">Create
                        Booking</button> -->
                    <button *ngIf="selectedTentative!=undefined" class="btn btn-outline-secondary" matStepperNext
                        (click)="flagstep1(false);ConfirmTentative(stepper);"
                        [disabled]="selectedTentative==undefined">Review
                        Quote</button>
                </div>
            </div>
        </mat-step>
        <!-- #enddocregion label -->
        <mat-step label="" state="">
            <div class="scrollarea">
                <div>
                    <div class=" instruction">How would you like to find a cruise?</div>

                    <div class="horizontalradio row">
                        <div class="col-4">
                            <input class="funnelselector" type="radio" id="bydate" name="findcruise" value="bydate"
                                (change)="selectedFilter = 'bydate'" />
                            <label for="bydate">By Date</label>
                        </div>
                        <div class="col-4">
                            <input class="funnelselector" type="radio" id="byregion" name="findcruise" value="byregion"
                                (change)="selectedFilter = 'byregion'" />
                            <label for="byregion">By Region</label>
                        </div>
                        <div class="col-4">
                            <input class="funnelselector" type="radio" id="bytheme" name="findcruise" value="bytheme"
                                (change)="selectedFilter = 'bytheme'" />
                            <label for="bytheme">By Theme</label>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedFilter=='bydate'">
                    <div class="tenpxtop"></div>
                    <div class=" instruction">Date Selection</div>

                    <div class="row">
                        <mat-form-field>
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [min]="minDate"
                                [max]="maxDate">
                                <input matStartDate formControlName="start" placeholder="Start date"
                                    (dateChange)="setStartDate(range.value.start!)">
                                <input matEndDate formControlName="end" placeholder="End date"
                                    (dateChange)="setEndDate(range.value.end!)">
                            </mat-date-range-input>
                            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>

                    </div>
                </div>
                <div *ngIf="selectedFilter=='byregion'">
                    <div class="tenpxtop"></div>
                    <div class=" instruction">Select a region</div>

                    <div class="row">
                        <div class="regionselection" *ngFor="let region of CruiseRegionsInfo; let i=index;">
                            <div class="row">
                                <div class="col-2"></div>
                                <div class="col-10 verticalradio">
                                    <div class="funnelitemlist">
                                        <input class="funnelselector" type="radio" id="region{{i}}"
                                            name="regionselector" value="{{region.creRegion}}"
                                            (change)="setRegion(region.creRegion)" />
                                        <label for="region{{i}}">{{region.creRegion}}</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div *ngIf="selectedFilter=='bytheme'">
                    <div class="tenpxtop"></div>
                    <div class=" instruction">Select a theme</div>

                    <div class="row themeselection">
                        <div class="regionselection" *ngFor="let theme of CruiseThemesInfo; let i=index;">
                            <div class="row">
                                <div class="col-2"></div>
                                <div class="col-10 verticalradio">
                                    <div class="funnelitemlist">
                                        <input class="funnelselector" type="radio" id="theme{{i}}" name="themeselector"
                                            value="theme.creTheme" (change)="setTheme(theme.creTheme)" />
                                        <label for="theme{{i}}">{{theme.creTheme}}</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="tenpxtop"></div>
                </div>
            </div>
            <div class="row OBbuttonarea">
                <div class="col-3">
                    <button class="btn btn-outline-secondary" mat-button matStepperPrevious
                        (click)="flagstep1(true)">Back</button>
                </div>
                <div class="col-6 circlesteps"><i class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i><i
                        class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i></div>
                <div class="col-3">
                    <button class="btn btn-outline-secondary" matStepperNext
                        [disabled]="selectedFilter==undefined || (selectedFilter=='bydate' && (selectedStartDate==undefined || selectedEndDate==undefined) || (selectedFilter=='byregion' && selectedRegion==undefined) || (selectedFilter=='bytheme' && selectedTheme==undefined))"
                        (click)="getCruiseItinerariesFiltered()">Next</button>
                </div>
            </div>
        </mat-step>
        <mat-step label="" state="">
            <div>
                <div class=" instruction">Select an Itinerary</div>

                <div class="scrollarea">

                    <div class="itineraryselection" *ngFor="let itinerary of CruiseItineraryInfo; let i=index;">
                        <div class="row">
                            <div class="col-1"></div>
                            <div class="col-11 verticalradio">
                                <div class="funnelitemlist">
                                    <input class="funnelselector" type="radio" id="itinerary{{i}}"
                                        name="itineraryselector" value="itinerary{{i}}"
                                        (change)="setItinerary(itinerary.creItinerary)" />
                                    <label for="theme{{i}}">{{itinerary.creItinerary}} - {{itinerary.duration+1}}
                                        days/{{itinerary.duration}} nights</label>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <div class="row OBbuttonarea">
                <div class="col-3">
                    <button class="btn btn-outline-secondary" mat-button matStepperPrevious>Back</button>
                </div>
                <div class="col-6 circlesteps"><i class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i><i
                        class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i>
                </div>
                <div class="col-3">
                    <button class="btn btn-outline-secondary" matStepperNext (click)="getCruiseShipsFiltered()"
                        [disabled]="selectedItinerary==undefined">Next</button>
                </div>
            </div>
        </mat-step>
        <mat-step label="" state="">
            <div>
                <div class=" instruction">Select a ship</div>

                <div class="scrollarea">

                    <div class="shipselection" *ngFor="let ship of CruiseShipInfo; let i=index;">
                        <div class="row">
                            <div class="col-1"></div>
                            <div class="col-11 verticalradio">
                                <div class="shipcategory"
                                    *ngIf="i==0 || CruiseShipInfo[i].shpShipStyle!=CruiseShipInfo[i-1].shpShipStyle">
                                    <input class="funnelselector" type="checkbox" id="shipstyle{{i}}"
                                        name="shipstyleselector{{i}}" value="shipstyle{{i}}"
                                        [checked]="ship.styleselected" (change)="setShipStyle(ship.shpShipStyle)" />
                                    {{ship.shpShipStyle}}
                                </div>
                                <div class="funnelitemlist">
                                    <input class="funnelselector" type="checkbox" id="ship{{i}}"
                                        name="shipselector{{i}}" value="ship{{i}}" [checked]="ship.selected"
                                        (change)="setShip(ship.shpId)" />
                                    <label for="ship{{i}}">{{ship.creshpShipName}}</label>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <div class="row OBbuttonarea">
                <div class="col-3">
                    <button class="btn btn-outline-secondary" mat-button matStepperPrevious>Back</button>
                </div>
                <div class="col-6 circlesteps"><i class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i><i
                        class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i>
                </div>
                <div class="col-3">
                    <button class="btn btn-outline-secondary" matStepperNext [disabled]="selectedShip==[]"
                        (click)="getCruiseEventsFiltered()">Next</button>
                </div>
            </div>
        </mat-step>

        <mat-step label="" state="">
            <div>
                <div class=" instruction">Click on a date and starting location for your cruise departure</div>
                <div class="row filterarea borderaround">
                    <!-- <div class="col-4 filterfont">
                        <i class="fa-solid fa-circle-plus fa-lg"></i> Filters
                    </div> -->


                    <div class="col-4 filterfont">

                        <a *ngIf="!filterexpander" (click)="filterexpander = !filterexpander"><i
                                class="fa-solid fa-circle-plus fa-lg"></i><span class="action"> Filter</span></a>
                        <a *ngIf="filterexpander" (click)="filterexpander = !filterexpander"><i
                                class="fa-solid fa-circle-minus fa-lg"></i><span class="action"> Close</span></a>
                    </div>
                    <div class="col-5 filterfont">
                        <div *ngIf="CruiseEventFilteredInfo!=undefined">{{CruiseEventFilteredInfo.length}} results
                        </div>
                    </div>
                    <div class="row innerexpand" *ngIf="filterexpander">
                        <div class="filteroptions">
                            <div class="datefilter">
                                <div class="filtersection">Departure Dates</div>
                                <div *ngFor="let month of monthselfilter; let i=index;">
                                    <div class="row yearrow">
                                        <div class="col-12 spacer"
                                            *ngIf="i==0 || monthselfilter[i].year!=monthselfilter[i-1].year">

                                        </div>
                                        <div class="col-3">
                                            <span class="yearsel"
                                                *ngIf="i==0 || monthselfilter[i].year!=monthselfilter[i-1].year"><input
                                                    type="checkbox" #inputEl [checked]="true"
                                                    (change)="setyear(month.year,inputEl.checked)">{{month.year}}</span>
                                        </div>
                                        <div class="col-9">
                                            <div class="row" *ngIf="i % 3 == 0">
                                                <div class="col-4">

                                                    <span>
                                                        <input type="checkbox" [(ngModel)]="monthselfilter[i].selected">
                                                        {{monthselfilter[i].monthname}}
                                                    </span>
                                                </div>
                                                <div class="col-4">
                                                    <span>
                                                        <input type="checkbox"
                                                            [(ngModel)]="monthselfilter[i+1].selected">
                                                        {{monthselfilter[i+1].monthname}}
                                                    </span>
                                                </div>
                                                <div class="col-4">
                                                    <span>
                                                        <input type="checkbox"
                                                            [(ngModel)]="monthselfilter[i+2].selected">
                                                        {{monthselfilter[i+2].monthname}}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="filteroptions" *ngIf="shipselfilter.length>1">
                            <div class="shipfilter">
                                <div class="filtersection">Ships</div>
                                <div *ngFor="let ship of shipselfilter; let i=index;">
                                    <input type="checkbox" [(ngModel)]="ship.selected">
                                    {{ship.ship}}
                                </div>
                            </div>
                        </div>
                        <div class="filteroptions" *ngIf="departportselfilter.length>1">
                            <div class="shipfilter">
                                <div class="filtersection">Departure Ports</div>
                                <div *ngFor="let port of departportselfilter; let i=index;">
                                    <input type="checkbox" [(ngModel)]="port.selected">
                                    {{port.port}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3"></div>
                            <div class="col-8">
                                <div class="pill" (click)="applyfilter();filterexpander = !filterexpander;">Apply</div>
                            </div>

                        </div>
                    </div>


                    <!-- <div class="col-3">
                        <div class="pill" (click)="applyfilter()">Edit</div>

                    </div> -->
                </div>
                <div class="">

                    <div class="itineraryselection" *ngFor="let event of CruiseEventFilteredInfo; let i=index;">
                        <div class="row">

                            <div class="col-12 verticalradio">
                                <div class="funnelitemlist longtextoption">
                                    <!-- <div class="col-1">
                                        <input class="funnelselector" type="radio" id="event{{i}}" name="eventselector"
                                            value="event{{i}}" (change)="setEvent(event.creevtuid)" />
                                    </div> -->
                                    <div class="col-12 eventselector" (click)="setEvent(event.creevtuid)"
                                        [ngClass]="{'eventselhighlight': selectedEvent === event.creevtuid && selectedEvent!=undefined}">
                                        <label for="event{{i}}"><span class="eventdate">{{event.creevtBegDate |
                                                date:'longDate'}}-{{event.creevtEndDate |
                                                date:'longDate'}}</span>
                                            <span
                                                class="eventportinfo">{{event.creStartPort}}-{{event.creEndPort}}</span>
                                            <span class="shipname">{{event.creshpShipName}}</span></label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- <div id="scrollcontainer">

                        <div class="scrolloverlay" [ngClass]="{'scrollhide':alreadyscrolled==true}">
                            <i class="fa-thin fa-chevrons-down"></i>
                        </div>
                    </div> -->
                </div>
            </div>

            <div class="row OBbuttonarea">
                <div class="col-3">
                    <button class="btn btn-outline-secondary" mat-button matStepperPrevious>Back</button>
                </div>
                <div class="col-6 circlesteps"><i class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i><i
                        class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i>
                </div>
                <div class="col-3">
                    <button class="btn btn-outline-secondary" matStepperNext (click)="getCategoriesForShip();"
                        [disabled]="selectedEvent==undefined">Next</button>
                </div>
            </div>
        </mat-step>
        <mat-step label="" state="">
            <div>
                <div class=" instruction">Select category and stateroom number</div>

                <div class="">
                    <div class="row">
                        <div class="col-1">

                        </div>
                        <div class="col-11">
                            <div class="itemcategory">Category</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-1">

                        </div>
                        <div class="col-11">
                            <div class="itineraryselection" *ngFor="let category of CategoryInfo; let i=index;">
                                <div class="row">
                                    <div class="col-1">

                                    </div>
                                    <div class="col-11 verticalradio">
                                        <div class="funnelitemlist deckcategories">
                                            <input class="funnelselector" type="radio" id="category{{i}}"
                                                name="eventselector" value="category{{i}}"
                                                (change)="setCategory(category.CategoryId)"
                                                [disabled]="category.AvailUnits==0" />
                                            <label for="category{{i}}"><span
                                                    class="catcolor cat-{{category.Code}}"></span>{{category.Name}}
                                                <span class="catprice" *ngIf="category.AvailUnits==0"> -
                                                    Sold Out </span>
                                                <span class="catprice"
                                                    *ngIf="numfolios == 1 && category.RegularCapacity==2 && category.AvailUnits>0">
                                                    -
                                                    <span class="redcross"> {{category.RateList[0].InfoPrice*
                                                        1.5| currency : 'USD' : 'symbol' : '1.0-0'}} </span>
                                                    {{(category.RateList[0].InfoPrice * 1.5) * .85|
                                                    currency}} </span>

                                                <span class="catprice"
                                                    *ngIf="(numfolios == 2 && category.RegularCapacity==2 && category.AvailUnits>0)||(numfolios == 1 && category.RegularCapacity==1 && category.AvailUnits>0)">
                                                    -
                                                    <span class="redcross">
                                                        {{category.RateList[0].InfoPrice| currency : 'USD' : 'symbol' :
                                                        '1.0-0'}} </span>{{category.RateList[0].InfoPrice
                                                    * .85| currency}} </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="obdiscmessage">*Price includes 15% Onboard Rebooking discount. All prices are per
                            person.</div>

                    </div>
                    <div class="row">
                        <div class="col-1">

                        </div>
                        <div class="col-11">
                            <div class="itemcategory" *ngIf="selectedCategory!=undefined">Room</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-1">

                        </div>
                        <div class="col-11">

                            <div class="itineraryselection" *ngIf="selectedCategory!=undefined">
                                <div class="row">
                                    <div class="row">
                                        <div class="col-1">

                                        </div>
                                        <div class="col-11">
                                            <select name="roomselector" [(ngModel)]="selectedRoom">
                                                <option value="" class="" selected="selected">
                                                    -- Select
                                                    Room --
                                                </option>
                                                <option value={{room.UnitId}}
                                                    *ngFor="let room of AvailRoomList; let i=index;">
                                                    {{room.Code}}</option>
                                            </select>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="categorydeckplan">
                        <!-- <app-deck-plans singledeck="false" imagetype="category">


                            inputshipId={{shipimage}}></app-deck-plans> -->
                        <!-- </app-deck-plans> -->
                        <div class="allshipimages ">


                            <div class="deckrows" *ngFor="let bannerimage of bannerimages; let i=index;">

                                <div class="tenpxtop"></div>
                                <div class="deckrow row" *ngIf="bannerimage.dplDeck!='Side'">
                                    <div class="deckname col-1"
                                        [ngClass]="{'deckhighlight':bannerimage.highlight==true}"
                                        *ngIf="bannerimage.dplDeck!='Side'">{{bannerimage.dplDeck}}</div>
                                    <div class="deckimage"
                                        [ngClass]="{'col-11 deck':bannerimage.dplDeck!='Side','col-12 profile':bannerimage.dplDeck=='Side'}">


                                        <img src="{{imagepath}}deckimages/{{bannerimage.dplCategoryImage}}"
                                            class="img-fluid" onerror="this.style.display='none'" alt="...">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row OBbuttonarea">
                    <div class="col-3">
                        <button class="btn btn-outline-secondary" mat-button matStepperPrevious>Back</button>
                    </div>
                    <div class="col-6 circlesteps"><i class="fa-light fa-circle"></i><i
                            class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i><i
                            class="fa-light fa-circle"></i>
                    </div>
                    <div class="col-3">
                        <button class="btn btn-outline-secondary" matStepperNext [disabled]="selectedEvent==undefined"
                            (click)="getAirItemsForCruise();getPreCruiseItemsForCruise();getPostCruiseItemsForCruise();getLandPackagesForCruise();getMidCruisePackagesForCruise();">Next</button>
                    </div>
                </div>
            </div>
        </mat-step>

        <mat-step label="" state="">
            <div>
                <div class=" instruction">Select additional items</div>

                <div class="">

                    <div class="itemcategory" *ngIf="AirInfo!=undefined && AirInfo.length>0">Airfare</div>
                    <div class="itineraryselection" *ngFor="let airitem of AirInfo; let i=index;">
                        <div class="row">
                            <div class="col-1"></div>
                            <div class="col-11 verticalradio">
                                <div class="funnelitemlist longtextoption ">
                                    <div class="col-1">
                                        <input class="funnelselector" type="radio" id="airitem{{i}}" name="airselector"
                                            value="airitem{{i}}" (change)="setAirItem(airitem.ItemId)" />
                                    </div>
                                    <div class="col-11">
                                        <label for="airitem{{i}}">{{airitem.Name}} <span class="price"
                                                *ngIf="airitem.RateList!=undefined && airitem.RateList[0].Price!=0">
                                                {{airitem.RateList[0].Price | currency}} Per Person</span><span
                                                class="price"
                                                *ngIf="airitem.RateList!=undefined && airitem.RateList[0].Price==0">
                                                Complimentary</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="itemcategory" *ngIf="PrecruiseInfo!=undefined && PrecruiseInfo.length>0">Pre Cruise
                        Additional Items</div>
                    <div class="itineraryselection" *ngFor="let precruiseitem of PrecruiseInfo; let i=index;">
                        <div class="row">
                            <div class="col-1"></div>
                            <div class="col-11 verticalradio">
                                <div class="funnelitemlist longtextoption ">
                                    <div class="col-1">
                                        <input class="funnelselector" type="radio" id="precruiseitem{{i}}"
                                            name="precruiseselector" value="precruiseitem{{i}}"
                                            (change)="setPrecruiseItem(precruiseitem.ItemId)" />
                                    </div>
                                    <div class="col-11">
                                        <label for="precruiseitem{{i}}">{{precruiseitem.Name}} <span class="price"
                                                *ngIf="precruiseitem.RateList!=undefined && precruiseitem.RateList[0].Price!=0">
                                                {{precruiseitem.RateList[0].Price | currency}} Per Person</span><span
                                                class="price"
                                                *ngIf="precruiseitem.RateList!=undefined && precruiseitem.RateList[0].Price==0">
                                                Complimentary</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="itemcategory" *ngIf="PostcruiseInfo!=undefined && PostcruiseInfo.length>0">Post Cruise
                        Additional Items</div>
                    <div class="itineraryselection" *ngFor="let postcruiseitem of PostcruiseInfo; let i=index;">
                        <div class="row">
                            <div class="col-1"></div>
                            <div class="col-11 verticalradio">
                                <div class="funnelitemlist longtextoption ">
                                    <input class="funnelselector" type="radio" id="postcruiseitem{{i}}"
                                        name="postcruiseselector" value="postcruiseitem{{i}}"
                                        (change)="setPostcruiseItem(postcruiseitem.ItemId)" />
                                    <label for="postcruiseitem{{i}}">{{postcruiseitem.Name}} <span class="price"
                                            *ngIf="postcruiseitem.RateList[0].Price!=0">
                                            {{postcruiseitem.RateList[0].Price | currency}}</span><span class="price"
                                            *ngIf="postcruiseitem.RateList[0].Price==0">
                                            Complimentary</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <div class="row OBbuttonarea">
                <div class="col-3">
                    <button class="btn btn-outline-secondary" mat-button matStepperPrevious>Back</button>
                </div>
                <div class="col-6 circlesteps"><i class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i><i
                        class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i>
                </div>
                <div class="col-3">
                    <button class="btn btn-outline-secondary" matStepperNext (click)="getCFAR();"
                        [disabled]="(AirInfo!=undefined && AirInfo.length>0 && selectedAir==undefined) ||(PrecruiseInfo!=undefined && PrecruiseInfo.length>0 &&selectedPreCruise==undefined) || (PostcruiseInfo!=undefined && PostcruiseInfo.length>0 && selectedPostCruise==undefined)">Next</button>
                </div>
            </div>
        </mat-step>
        <mat-step label="" state="">
            <div>
                <div class=" instruction">Select Cruise Cancellation Protection Plan</div>

                <div class="" *ngIf="CFARInfo !=undefined">



                    <div class="row">


                        <div class="funnelitemlist longtextoption">
                            <div class="col-1"></div>
                            <div class="col-11" class="funnelselector">

                                <input type="radio" name="cfarselect" id="cfarselectoption" required
                                    value="CFARInfo[1].ItemId+':M'" (change)="setCFARItem(CFARInfo[1].ItemId+':M')">

                                <label for="cfarselectoption">
                                    Confirm Cancellation
                                    Protection
                                    Plan

                                    <span class="price">
                                        {{
                                        CFARInfo[1].RateList[0].Price |
                                        currency:"$"
                                        }} Per Person

                                    </span></label>
                            </div>



                        </div>
                    </div>
                    <div class="row">
                        <div class="funnelitemlist longtextoption">
                            <div class="col-1"></div>
                            <div class="col-11" class="funnelselector">

                                <input type="radio" name="cfarselect" id="cfarselectdecline" ng-required="true"
                                    value="CFARInfo[0].ItemId" (change)="setCFARItem(CFARInfo[0].ItemId)">

                                <label for="cfarselectdecline">
                                    Decline Cancellation
                                    Protection
                                    Plan
                                </label>

                            </div>
                        </div>
                    </div>

                </div>

            </div>


            <div class="row OBbuttonarea">
                <div class="col-3">
                    <button class="btn btn-outline-secondary" mat-button matStepperPrevious>Back</button>
                </div>
                <div class="col-4 circlesteps"><i class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i><i
                        class="fa-light fa-circle"></i><i class="fa-light fa-circle"></i>
                </div>
                <div class="col-5">
                    <button class="btn btn-outline-secondary" matStepperNext [disabled]="selectedCFAR==undefined"
                        (click)="makeTentativeBooking();">Create
                        Quote</button>
                </div>
            </div>
        </mat-step>

        <mat-step label="Step 3">
            <div>
                <div class=" instruction">Please click below to confirm this booking.</div>

                <div class="">
                    <div class=" ">

                        <div class="bookingselection">
                            <div *ngFor="let tentative of FolioBookingsInfo; let i=index;">


                                <div
                                    *ngIf="BookingInfo != undefined && (tentative.rebuid == BookingInfo.bookingId || tentative.rebuid == BookingInfo.rebuid)">
                                    <div class="col-12 eventselector">

                                        <div class="row ">
                                            <div class="col-1"></div>
                                            <div class="col-11">
                                                <div class="itineraryname">{{tentative.CruiseName}}</div>
                                                <div class="departuredate">{{tentative.DepartureDate |
                                                    date:'mediumDate'}} -
                                                    {{tentative.EndDate | date:'mediumDate'}}</div>
                                                <div class="shipname">{{tentative.Ship}}<span class="roomcat">
                                                        - {{tentative.RoomCat}}</span></div>
                                                <div class="departurecity">{{tentative.Starting}} - {{tentative.Ending}}
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div class="tenpxtop"></div>
                                    <div class="paymentinfo">

                                        <form id="paymentForm" name="paymentForm">
                                            <div>
                                                <div class="row cruisepackagesection">
                                                    <div class="col-9 ">

                                                        <div class="cruisepackage" *ngIf="CFARBookingInfo!=undefined">

                                                            Cruise Package
                                                        </div>
                                                    </div>


                                                    <div class="col-3 amtvalue" *ngIf="BookingBalanceInfo!=undefined">
                                                        <div class="cruisepackage">{{BookingBalanceInfo.Balance |
                                                            currency:"$"}}</div>
                                                    </div>


                                                </div>

                                                <div class="subtotals"
                                                    *ngFor="let trans of BookingTransactionInfo; let i=index;">
                                                    <div class="row transdetails"
                                                        *ngIf="trans.BaseMessage!='Hotel Declined'">
                                                        <div *ngIf="trans.DepartmentType!='DR' && trans.BaseMessage!='CFAR Declined' && trans.BaseMessage!='Complimentary Shore Tours'"
                                                            class="col-9 amttext detailsection">

                                                            <div> {{trans.BaseMessage}}</div>
                                                        </div>
                                                        <div *ngIf="trans.DepartmentType!='DR' && trans.BaseMessage=='CFAR Declined'"
                                                            class="col-9 amttext detailsection">

                                                            <div> Cruise Cancellation Protection</div>
                                                        </div>
                                                        <div *ngIf="trans.DepartmentType!='DR' && trans.BaseMessage=='Complimentary Shore Tours'"
                                                            class="col-9 amttext detailsection">

                                                            <div> Complimentary Featured Shore Excursions</div>
                                                        </div>
                                                        <div *ngIf="trans.DepartmentType=='DR'"
                                                            class="col-9 amttext  detailsection">
                                                            <div> Cruise Fare</div>
                                                        </div>
                                                        <div class="col-3 amtvalue "
                                                            *ngIf="trans.BaseMessage!='CFAR Declined'">
                                                            <div>{{trans.potValue | currency:"$"}}</div>
                                                        </div>
                                                        <div *ngIf="trans.BaseMessage=='CFAR Declined'"
                                                            class="col-3 amtvalue">

                                                            <div> Not Added</div>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div class="confirmamountsection">
                                                    <div class=""
                                                        *ngIf="CFARBookingInfo != undefined &&  CFARBookingInfo[0].GroupType !=undefined &&  CFARBookingInfo[0].GroupType=='P' && BookingPriceInfo.chargePrice != 'full'">
                                                        <div class="row">
                                                            <div class="amttext col-9   amttext3row">
                                                                <div>Amount Due Today to Confirm This Booking</div>
                                                            </div>
                                                            <div class="col-3 amtvalue">
                                                                <div *ngIf="BookingPriceInfo!=undefined">
                                                                    {{parseFloat(BookingPriceInfo.chargePrice) +
                                                                    (CFARBookingInfo[0].RateList[0].Price *
                                                                    numfolios) | currency:"$"}}
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class=""
                                                        *ngIf="CFARBookingInfo != undefined &&  CFARBookingInfo[0].GroupType !=undefined &&  CFARBookingInfo[0].GroupType=='D' && BookingPriceInfo.chargePrice != 'full'">
                                                        <div class="row">
                                                            <div class="amttext col-9   amttext3row">
                                                                <div>Amount Due Today to Confirm This Booking</div>
                                                            </div>
                                                            <div class="col-3 amtvalue">
                                                                <div *ngIf="BookingPriceInfo!=undefined">
                                                                    {{parseFloat(BookingPriceInfo.chargePrice) |
                                                                    currency:"$"}}
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class=""
                                                        *ngIf="CFARBookingInfo != undefined && BookingPriceInfo.chargePrice == 'full'">
                                                        <div class="row">
                                                            <div class="amttext col-9   amttext3row">
                                                                <div>Amount Due Today to Confirm This Booking</div>
                                                            </div>
                                                            <div class="col-3 amtvalue">
                                                                <div *ngIf="BookingPriceInfo!=undefined">
                                                                    {{BookingBalanceInfo.Balance | currency:"$"}}
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                                <div class="confirmtentativelink"
                                    *ngIf="BookingInfo != undefined && (tentative.rebuid == BookingInfo.bookingId || tentative.rebuid == BookingInfo.rebuid)">
                                    <button class="btn btn-light nav-item nav-link-edit"><a class="shorexlink"
                                            href="{{confirmBookingUrl}}customernumber={{tentative.folRepeaterNo}}&lastname={{tentative.folSurName}}&rebuid={{bookingID}}&source=AX">Confirm
                                            this Booking</a></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--confirm tentative link-->

                    <!-- payment form -->
                    <!-- <div class="payment-options-form">

                        <form id="paymentForm" name="paymentForm" #paymentForm="ngForm" ngNativeValidate>
                            <div class="form-title">
                                <div>Credit Card Information</div>

                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group success">
                                        <label id="DepositFirstNameLabel" for="DepositFirstName">Which guest is making
                                            the payment?<span
                                                class="reqasterisk"><strong>*</strong></span></label><br />
                                        <div class="guestselection"
                                            *ngFor="let bookingguest of BookingGuestsInfo; let i=index;">
                                            <div class="row">
                                                <div class="col-2"></div>
                                                <div class="col-10">
                                                    <div class="funnelitemlist">
                                                        <input class="funnelselector" type="radio" id="guest{{i}}"
                                                            name="guestselector" value={{bookingguest.foluid}}
                                                            [(ngModel)]="selFolio" />
                                                        
                                                        <label for="guest{{i}}">{{bookingguest.folFullNameSal}}</label>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>


                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group success">

                                        <label id="DepositFirstNameLabel" for="DepositFirstName">Name on Card<span
                                                class="reqasterisk"><strong>*</strong></span></label>
                                        <input class="form-control " data-val="true" required id="DepositFirstName"
                                            [(ngModel)]="thiscardholder.DepositLastName" name="DepositFirstName"
                                            placeholder="First Name" type="text" aria-required="true">
                                        <input class="form-control " data-val="true" required id="DepositLastName"
                                            [(ngModel)]="thiscardholder.DepositFirstName" name="DepositLastName"
                                            placeholder="Last Name" style="margin-top:20px" type="text" value=""
                                            aria-required="true" aria-invalid="false">
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group success">
                                        <label id="DepositZipCodeLabel" for="DepositZipCode">Billing Zip Code<span
                                                class="reqasterisk"><strong>*</strong></span></label>
                                        <input class="form-control " data-val="true" required id="DepositZipCode"
                                            name="DepositZipCode" placeholder="Billing Zip Code" type="text"
                                            [(ngModel)]="thiscardholder.DepositZipCode" aria-required="true"
                                            aria-invalid="false">
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group success">
                                        <label id="DepositCardNumberLabel" for="DepositCardNumber">Card Number<span
                                                class="reqasterisk"><strong>*</strong></span></label>
                                        <input class="form-control " data-val="true" required id="DepositCardNumber"
                                            [(ngModel)]="thiscardholder.DepositCardNumber" name="DepositCardNumber"
                                            type="text" value="" autocomplete="off" aria-required="true"
                                            aria-invalid="false"><label id="DepositCardNumber-error" class="error"
                                            for="DepositCardNumber" style="display: none;"></label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="card-payment-options">
                                            <img src="https://aclmedia.azureedge.net/cmsmedia/libraries/acl/images/booking/payment-types/pay-visa-icon.svg"
                                                alt="Visa">
                                            <img src="https://aclmedia.azureedge.net/cmsmedia/libraries/acl/images/booking/payment-types/pay-mastercard-icon.svg"
                                                alt="Mastercard">
                                            <img src="https://aclmedia.azureedge.net/cmsmedia/libraries/acl/images/booking/payment-types/pay-discover-icon.svg"
                                                alt="Discover">
                                            <img src="https://aclmedia.azureedge.net/cmsmedia/libraries/acl/images/booking/payment-types/pay-american-express-icon.svg"
                                                alt="American Express">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label id="DepositExpirationMonthLabel" for="DepositExpirationMonth"> Expiration
                                            Date<span class="reqasterisk"><strong>*</strong></span></label>
                                        <div class="form-group two-fileds-horziontal">
                                            <div class="text-left">
                                                <select id="DepositExpirationMonth" required
                                                    name="DepositExpirationMonth" aria-required="true"
                                                    aria-invalid="false" class="valid"
                                                    [(ngModel)]="thiscardholder.DepositExpirationMonth">
                                                    <option value="">Month</option>
                                                    <option value="01">01</option>
                                                    <option value="02">02</option>
                                                    <option value="03">03</option>
                                                    <option value="04">04</option>
                                                    <option value="05">05</option>
                                                    <option value="06">06</option>
                                                    <option value="07">07</option>
                                                    <option value="08">08</option>
                                                    <option value="09">09</option>
                                                    <option value="10">10</option>
                                                    <option value="11">11</option>
                                                    <option value="12">12</option>
                                                </select>
                                            </div>
                                            <div class="text-right">
                                                <select class="text-left " id="DepositExpirationYear" required
                                                    name="DepositExpirationYear" aria-required="true"
                                                    [(ngModel)]="thiscardholder.DepositExpirationYear"
                                                    aria-invalid="false">
                                                    <option value="">Year</option>

                                                    <option value="2024">2024</option>
                                                    <option value="2025">2025</option>
                                                    <option value="2026">2026</option>
                                                    <option value="2027">2027</option>
                                                    <option value="2028">2028</option>
                                                    <option value="2029">2029</option>
                                                    <option value="2030">2030</option>
                                                    <option value="2031">2031</option>
                                                    <option value="2032">2021</option>
                                                    <option value="2023">2022</option>
                                                    <option value="2034">2023</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-12 security-form-control">
                                    <div class="form-group success">
                                        <label for="DepositCardAuthorizationCode">

                                            <span id="DepositCardAuthorizationCodeLabel">Security Code</span><span
                                                class="reqasterisk"><strong>*</strong></span>
                                            <span class="card-payment-options">
                                                <img src="https://aclmedia.azureedge.net/cmsmedia/libraries/acl/images/booking/payment-types/pay-backcard-icon.svg"
                                                    alt="Back">
                                            </span>
                                        </label>

                                        <input class="form-control inputCardAuthorizationCode" data-val="true" required
                                            id="DepositCardAuthorizationCode" name="DepositCardAuthorizationCode"
                                            type="text" [(ngModel)]="thiscardholder.DepositCardAuthorizationCode"
                                            aria-required="true" aria-invalid="false">
                                    </div>

                                </div>

                            </div>
                            <div class="row">
                                <div class="row col-12 paymentoptions">
                                    <div class="col-1"></div>
                                    <div *ngIf="BookingPriceInfo != undefined && BookingPriceInfo.chargePrice != 'full' && CFARBookingInfo != undefined &&  CFARBookingInfo[0].GroupType !=undefined &&  CFARBookingInfo[0].GroupType !=undefined &&  CFARBookingInfo[0].GroupType=='P'"
                                        class="col-11">
                                        <input id="paymentopt" type="radio" name="PaymentOption" value="paymentAmount"
                                            ng-model="PaymentOption" ng-required="daystocruise>90" class="" required
                                            [(ngModel)]="thiscardholder.PaymentOption">
                                        <label class="cfarconfirm ng-binding"> Pay the Deposit
                                            ({{parseFloat(BookingPriceInfo.chargePrice) +
                                            (CFARBookingInfo[0].RateList[0].Price *
                                            numfolios)| currency:"$"}}) </label><br>
                                    </div>
                                    <div *ngIf="BookingPriceInfo != undefined && BookingPriceInfo.chargePrice != 'full' && CFARBookingInfo != undefined &&  CFARBookingInfo[0].GroupType !=undefined &&  CFARBookingInfo[0].GroupType=='D'"
                                        class="col-11">
                                        <input id="paymentopt" type="radio" name="PaymentOption" value="paymentAmount"
                                            ng-model="PaymentOption" [(ngModel)]="thiscardholder.PaymentOption"
                                            required>
                                        <label class="cfarconfirm ng-binding"> Pay the Deposit
                                            ({{parseFloat(BookingPriceInfo.chargePrice)| currency:"$"}}) </label><br>
                                    </div>
                                </div>
                                <div class="row col-12 paymentoptions">
                                    <div class="col-1"></div>
                                    <div *ngIf="BookingBalanceInfo != undefined" class="col-11">
                                        <input id="paymentopt" type="radio" name="PaymentOption" value="AmountBooking"
                                            [(ngModel)]="thiscardholder.PaymentOption"
                                            class="ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required"
                                            required="required">
                                        <label class="cfarconfirm ng-binding">
                                            Pay the Full Amount ({{BookingBalanceInfo.Balance | currency:"$"}})
                                        </label>
                                    </div>



                                </div>


                            </div>
                            <div class="row">

                                <div class="col-12  security-form-control">
                                    <div class="form-group outerterms">

                                        <input type="checkbox" id="termscond" name="termscond"
                                            [(ngModel)]="thiscardholder.TermsAccept">
                                        <span class="line1 foundhere"> I agree to the <a
                                                href="https://www.americancruiselines.com/general-information/terms-and-conditions"
                                                target="_blank">Terms and Conditions of Passage</a></span><br>
                                        <span class="line1 foundhere"> and the <a
                                                href="https://www.americancruiselines.com/passenger-cancellation-terms"
                                                target="_blank"> Cancellation
                                                Terms</a></span>
                                    </div>
                                </div>


                            </div>
                            <div class="row">


                                <div class="col-12 security-form-control">
                                    <div class="form-group">
                                        <button
                                            [disabled]="paymentForm.invalid || thiscardholder.TermsAccept!=true || selFolio==undefined"
                                            id="btnPrevious" class="btn  btn-md btn-outline-secondary" type="button"
                                            (click)="sendPaymentDataToAnet()">Process
                                            Payment</button>
                                        <div ng-show="paymenterror!=undefined" class="rednotice">{{paymenterror}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <img class="img-responsive norton-logo"
                                        src="https://aclmedia.azureedge.net/cmsmedia/libraries/acl/images/style-assets/payments/pay-norton-logo-min.png"
                                        alt="Norton">
                                </div>

                            </div>

                        </form>
                    </div>  -->
                    <!--end paymentform-->
                </div>
            </div>
        </mat-step>
        <mat-step label="" state="">
            <div>


                <div class="thankyou">
                    Thank you for booking your cruise. We look forward to seeing you onboard again.
                </div>
                <div class="messages">
                    A receipt will be sent with the details of your cruise to your email on file.
                </div>


            </div>


        </mat-step>
    </mat-stepper>
</div>